import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

/**
 * Generated class for the FormatJobLocationsPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatJobLocations',
})
export class FormatJobLocationsPipe implements PipeTransform {
  /**
   * Takes a job and displays the list of location in a human readable format
   * for the job card (based on type and # of locations)
   */

  formatOtrLocations = function (states, radiuses) {
    let sortedStates = (states || []).slice().sort();
    let sortedRadius = _.sortBy((radiuses || []).slice(), d => {
      return String(d.cityState || '').toLowerCase();
    })
      .map(_.property('cityState'))
      .filter(_.identity);

    if (_.size(sortedRadius) > 10) {
      sortedRadius = [sortedRadius.length + ' cities'];
    }

    if (!_.size(sortedStates) && !_.size(sortedRadius)) {
      return 'No locations specified';
    }

    return getText(getList());

    function getText(list) {
      return list.join(' • ');
    }

    function getList() {
      let list = [];
      let DC = _.includes(states, 'DC');

      if (sortedStates.length > 10) {
        if (DC) {
          sortedStates.pop(); // just remove a random one
          list = _.union([sortedStates.length + ' states', 'DC'], sortedRadius);
        } else {
          list = _.union([sortedStates.length + ' states'], sortedRadius);
        }
      } else {
        list = _.union(sortedStates, sortedRadius);
      }

      return list;
    }
  };

  formatLocations = function (locations) {
    let locs = (locations || []).map(d => d.cityState).sort();
    let last = locs.pop() || '';
    let s = ' and ';
    let str = '';

    if (!_.size(locations)) {
      return '';
    }
    if (!locs.length) str = last;
    if (locs.length > 1) s = ', and ';
    str = locs.join(', ') + s + last;

    if (_.size(str) > 65) {
      return locs.length + 1 + ' locations';
    }
    return str;
  };

  transform(job: any, ...args) {
    if (_.get(job, 'hiringAreasMetadata.count')) {
      return _.get(job, 'hiringAreasMetadata.count') + ' locations';
    }

    if (job.type === 'otr') {
      return this.formatOtrLocations(job.operatingStates, job.stops);
    }
    // every other type: route, otr-freeform, tenstreet, radius (deprecated)
    else if (job.type !== 'otr-freeform') {
      return this.formatLocations(job.stops);
    }
    // otr-freeform and everything else
    else {
      return 'No Stops Specified';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-job-locations/format-job-locations.ts